import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { ChargePointListActionsCell } from './charge-point-list-actions.cell';
import { ChargePointListActionsHeader } from './charge-point-list-actions.header';

export const ChargePointListActionsColumn: DisplayColumnDef<
  GatewayChargePointModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: ChargePointListActionsHeader,
  cell: ChargePointListActionsCell,
};
